// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3XqZz","text":"SelectPayment_text__1n-T1","title":"SelectPayment_title__2Jsib","btn":"SelectPayment_btn__TfeoC"};